import type { CheckoutEstimateReturnRequestDto, CheckoutEstimateResultDto } from "../generated/schema";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";

export async function publicCheckoutEstimate(
	body: CheckoutEstimateReturnRequestDto,
): Promise<CheckoutEstimateResultDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/checkout/estimate",
		{ params: { header: getPublicAuthHeader() }, body },
	);
	if (error) throw error;
	return data;
}

export function usePublicCheckoutEstimate() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/checkout/estimate",
		{
			mapVariables: (body: CheckoutEstimateReturnRequestDto) => ({
				params: { header: getPublicAuthHeader() },
				body,
			}),
		},
	);
}
